
<!--
  This example requires Tailwind CSS v3.0+

  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
-->
<template>
    <TransitionRoot :show="open" as="template" @after-leave="query = ''">
        <Dialog as="div" class="fixed inset-0 z-10 overflow-y-auto p-4 sm:p-6 md:p-20" @close="$emit('close')">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity" />
            </TransitionChild>

            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 scale-95" enter-to="opacity-100 scale-100" leave="ease-in duration-200" leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
                <Combobox as="div" class="mx-auto max-w-2xl transform divide-y divide-gray-500 divide-opacity-20 overflow-hidden rounded-xl bg-gray-900 shadow-2xl transition-all">
                    <div class="relative">
                        <SearchIcon class="pointer-events-none absolute top-3.5 left-4 h-5 w-5 text-gray-500" aria-hidden="true" />
                        <ComboboxInput class="h-12 w-full border-0 bg-transparent pl-11 pr-4 text-white placeholder-gray-500 focus:ring-0 sm:text-sm" placeholder="Wyszukaj produkty..." @change="(event) => { query = event.target.value }" @keyup.enter="search()" />
                    </div>
                </Combobox>
            </TransitionChild>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import { computed, ref } from 'vue'
import { SearchIcon } from '@heroicons/vue/solid'
import {
    Combobox,
    ComboboxInput,
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'
import router from '../../router'

export default {
    name: "SearchPanel",
    components: {
        Combobox,
        ComboboxInput,
        Dialog,
        DialogOverlay,
        SearchIcon,
        TransitionChild,
        TransitionRoot,
    },
    props: {
        open: Boolean,
    },
    data: () => ({
        query: '',
    }),
    methods: {
        search(event) {
            if (this.query) {
                router.push({
                    name: 'offer',
                    query: {
                        keywords: this.query,
                    },
                });
                this.$emit('close');
            }
        }
    }
}
</script>
